import {IBreadProgram, Schedule, Note} from '../models/BreadProgramModel'

export enum EBreadProgramType {
  GET_LIST_BREAD_PROGRAM = '[manage Bread Program] GET_LIST_BREAD_PROGRAM',
  GET_LIST_BREAD_PROGRAM_LOADING = '[manage Bread Program] GET_LIST_BREAD_PROGRAM_LOADING',
  SAVE_BREAD_PROGRAM_RD = '[manage Bread Program] SAVE_BREAD_PROGRAM_RD',
  ADD_NEW_BREAD_PROGRAM = '[manage Bread Program] ADD_NEW_BREAD_PROGRAM',
  EDIT_BREAD_PROGRAM = '[manage Bread Program] EDIT_BREAD_PROGRAM',
  DELETE_ITEM_BREAD_PROGRAM = '[manage Bread Program] DELETE_ITEM_BREAD_PROGRAM',
  GET_ITEM_BREAD_PROGRAM = '[manage Bread Program] GET_ITEM_BREAD_PROGRAM',
  GET_SCHEDULE_BENEFICIARY = '[manage Bread Program] GET_SCHEDULE_BENEFICIARY',
  GET_SCHEDULE_BENEFICIARY_LOADING = '[manage Bread Program] GET_SCHEDULE_BENEFICIARY_LOADING',
  GET_SCHEDULE_BENEFICIARY_SUCCES = '[manage Bread Program] GET_SCHEDULE_BENEFICIARY_SUCCES',
  CREATE_SCHEDULE = '[manage Bread Program] CREATE_SCHEDULE',
  DELETE_SCHEDULE = '[manage Bread Program] DELETE_SCHEDULE',
  GET_LIST_NOTE = '[manage Bread Program] GET_LIST_NOTE',
  GET_LIST_NOTE_SUCCESS = '[manage Bread Program] GET_LIST_NOTE_SUCCESS',
  CREATE_NOTE = '[manage Bread Program] CREATE_NOTE',
  DELETE_NOTE = '[manage Bread Program] DELETE_NOTE',
}

// ======================== BREAD_PROGRAM =========================== //

export const getListBreadProgramAction = () => ({
  type: EBreadProgramType.GET_LIST_BREAD_PROGRAM,
})

export const setListBreadProgramLoadingAction = (loading: boolean) => ({
  type: EBreadProgramType.GET_LIST_BREAD_PROGRAM_LOADING,
  payload: loading,
})

export const saveListBreadProgramAction = (payload: IBreadProgram[]) => ({
  type: EBreadProgramType.SAVE_BREAD_PROGRAM_RD,
  payload,
})

export const getItemBreadProgramAction = (payload: any) => ({
  type: EBreadProgramType.GET_ITEM_BREAD_PROGRAM,
  payload,
})

export const addNewBreadBrogramAction = (payload: {
  value: any
  onSuccess: any
  onError: any
}) => ({
  type: EBreadProgramType.ADD_NEW_BREAD_PROGRAM,
  payload,
})

export const editBreadProgramAction = (payload: {
  value: any
  onSuccess: any
  onError: any
}) => ({
  type: EBreadProgramType.EDIT_BREAD_PROGRAM,
  payload,
})

export const deleteBreadProgramAction = (payload: {id: any; onSuccess: any; onError: any}) => ({
  type: EBreadProgramType.DELETE_ITEM_BREAD_PROGRAM,
  payload,
})

export const getScheduleAction = (payload: {beneficiaryId: string}) => ({
  type: EBreadProgramType.GET_SCHEDULE_BENEFICIARY,
  payload,
})

export const setScheduleLoadingAction = (loading: boolean) => ({
  type: EBreadProgramType.GET_SCHEDULE_BENEFICIARY_LOADING,
  payload: loading,
})

export const getScheduleSuccesAction = (payload: Schedule[]) => ({
  type: EBreadProgramType.GET_SCHEDULE_BENEFICIARY_SUCCES,
  payload,
})

export const createScheduleAction = (payload: {item: Schedule; onSuccess: any; onError: any}) => ({
  type: EBreadProgramType.CREATE_SCHEDULE,
  payload,
})

export const deleteScheduleAction = (payload: {id: any; onSuccess: any; onError: any}) => ({
  type: EBreadProgramType.DELETE_SCHEDULE,
  payload,
})

export const getListNoteAction = (payload: {id: any}) => ({
  type: EBreadProgramType.GET_LIST_NOTE,
  payload,
})

export const getListNoteActionSuccess = (payload: any) => ({
  type: EBreadProgramType.GET_LIST_NOTE_SUCCESS,
  payload,
})

export const createNoteAction = (payload: {noteItem: any; onSuccess: any; onError: any}) => ({
  type: EBreadProgramType.CREATE_NOTE,
  payload,
})

export const deleteNoteAction = (payload: {id: any; onSuccess: any; onError: any}) => ({
  type: EBreadProgramType.DELETE_NOTE,
  payload,
})
